module.exports = __webpack_public_path__ + "static/media/combat(6).033f47d2.PNG";